import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBoxProps {
  defaultValue?: string;
  variant?: "navbar" | "hero";
  placeholder?: string;
}

export default function SearchBox({
  defaultValue = "",
  variant = "navbar",
  placeholder = "搜索日剧、电影、演员…",
}: SearchBoxProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const q = value.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const isHero = variant === "hero";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={
        isHero
          ? "flex w-full max-w-2xl items-center gap-2 rounded-full bg-background-50 p-1.5 pl-5"
          : "flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 py-1.5"
      }
    >
      <span className="flex h-5 w-5 shrink-0 items-center justify-center text-foreground-400">
        <i className="ri-search-line text-base" aria-hidden="true"></i>
      </span>
      <input
        type="text"
        name="q"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        aria-label="搜索影视内容"
        className="min-w-0 flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
      />
      <button
        type="submit"
        className={
          isHero
            ? "flex shrink-0 items-center gap-1 rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            : "flex shrink-0 items-center gap-1 rounded-full bg-primary-500 px-4 py-1.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        }
      >
        <i className="ri-search-line" aria-hidden="true"></i>
        搜索
      </button>
    </form>
  );
}